export const FormSectionHeader = ({ title }) => {
  return (
    <div className="text-center text-muted mt-3 mb-5">
      <h5 className="m-0">{title}</h5>
    </div>
  );
};
